import React, { useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import ImageModal from './config/image-modal'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

function Section5() {
    const [selectedData, setSelectedData] = useState(null)
    const [showImageModal, setShowImageModal] = useState(false)
    const [showBookingModal, setShowBookingModal] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [submitMessage, setSubmitMessage] = useState('')
    
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        numberOfPeople: '2',
        bookingDate: '',
        bookingTime: '',
        email: '',
        phone: ''
    })
    
    const handleSelectedData = (datac) => {
        setSelectedData(datac)
        setShowImageModal(true)
    };

    const handleCloseImageModal = () => {
        setShowImageModal(false)
    }

    const handleShowBookingModal = () => {
        setShowBookingModal(true)
        setSubmitMessage('') // Clear previous messages
    }

    const handleCloseBookingModal = () => {
        setShowBookingModal(false)
        // Reset form after modal closes
        setTimeout(() => {
            setFormData({
                name: '',
                surname: '',
                numberOfPeople: '2',
                bookingDate: '',
                bookingTime: '',
                email: '',
                phone: ''
            })
            setSubmitMessage('')
        }, 300)
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsSubmitting(true)
        setSubmitMessage('')
        
        // Validate form data
        if (!formData.name || !formData.surname || !formData.bookingDate || !formData.bookingTime || !formData.email || !formData.phone) {
            setSubmitMessage('❌ Please fill in all required fields.')
            setIsSubmitting(false)
            return
        }

        console.log('Form data being submitted:', formData)
        
        try {
            // Your Power Automate URL
            const powerAutomateUrl = 'https://default840d061aed484385a916c770868c12.86.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/fb57d6f1d1614b738172c31e0213a7f7/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=9vLWwwizthve5xL4BhxHQbDosLOP0rFsBjO7bjTONaE';
            
            console.log('Sending request to:', powerAutomateUrl)
            
            const requestBody = {
                ...formData,
                submittedAt: new Date().toISOString(),
                source: 'Mila Website Booking Form'
            };
            
            console.log('Request body:', requestBody)
            
            const response = await fetch(powerAutomateUrl, {
                method: 'POST',
                mode: 'cors', // Explicitly set CORS mode
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(requestBody),
            });
            
            console.log('Response status:', response.status)
            console.log('Response headers:', Object.fromEntries(response.headers.entries()))
            
            if (response.ok) {
                try {
                    const result = await response.json();
                    console.log('Response data:', result)
                    setSubmitMessage('✅ Booking request submitted successfully! We will contact you soon.');
                    
                    // Close modal after 3 seconds
                    setTimeout(() => {
                        handleCloseBookingModal();
                    }, 3000);
                } catch (jsonError) {
                    console.log('Response was ok but no JSON:', jsonError)
                    setSubmitMessage('✅ Booking submitted! (No confirmation received)');
                    setTimeout(() => {
                        handleCloseBookingModal();
                    }, 3000);
                }
            } else {
                const errorText = await response.text();
                console.error('Response not OK:', response.status, errorText);
                throw new Error(`Failed to submit booking. Status: ${response.status}`);
            }
        } catch (error) {
            console.error('Error submitting booking:', error);
            console.error('Error details:', error.message, error.stack);
            
            // Check for specific CORS error
            if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
                setSubmitMessage('❌ Network error. Please check your connection or contact us directly at +971 00 000 0000');
            } else if (error.message.includes('CORS')) {
                setSubmitMessage('❌ Server configuration error. Please contact us directly at +971 00 000 0000');
            } else {
                setSubmitMessage(`❌ Failed to submit booking: ${error.message}. Please contact us directly at +971 00 000 0000`);
            }
        } finally {
            setIsSubmitting(false);
        }
    }

    // Header image URL
    const headerImage = "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/bookings/Artboard 5.png";
    
    // Mila logo for modal header
    const milaLogo = "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/elements/Mila bookings.webp";
    
    // Exactly 4 images as shown in screenshot
    const images = [
        { 
            src: "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/bookings/beach loungers.webp",
            title: "SUN BEDS"
        },
        { 
            src: "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/bookings/beach beanbags.webp",
            title: "BEANBAGS" 
        },
        { 
            src: "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/bookings/cabana.webp",
            title: "CABANA"
        },
        { 
            src: "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/bookings/lounge image.webp",
            title: "LOUNGE AREA"
        }
    ];

    return (
        <>
            <div id="section5" className="section5 section4 mt-scroll pb-5 scroll-div" style={{ backgroundColor: '#f0e7da' }}>
                <Container>
                    {/* Header Image - Centered - ADDED SPACE BELOW */}
                    <Row className="justify-content-center">
                        <Col xs={12} className="text-center">
                            <div className="d-flex justify-content-center">
                                <Image 
                                    src={headerImage} 
                                    alt="Header"
                                    style={{
                                        maxWidth: '250px',
                                        width: '100%',
                                        height: 'auto',
                                        marginBottom: '40px' // Increased from 10px to 40px for more space
                                    }}
                                    onClick={() => handleSelectedData(headerImage)}
                                />
                            </div>
                        </Col>
                    </Row>
                    
                    {/* 4 Booking Images - DOUBLED IN SIZE */}
                    <Row className="justify-content-center align-items-center mb-4">
                        {images.map((item, index) => (
                            <Col key={index} xs={6} md={3} className="text-center mb-4">
                                <Image 
                                    src={item.src} 
                                    fluid
                                    data-aos="fade-up" 
                                    data-aos-duration="2500"
                                    style={{ 
                                        width: '100%',
                                        maxWidth: '300px', // Changed from 150px to 300px (doubled)
                                        height: '300px', // Changed from 150px to 300px (doubled)
                                        objectFit: 'cover',
                                        marginBottom: '8px'
                                    }}
                                    onClick={() => handleSelectedData(item.src)}
                                />
                                <div style={{ 
                                    fontWeight: 'bold', 
                                    fontSize: '0.9rem',
                                    color: '#003594' // Added color #003594
                                }}>
                                    {item.title}
                                </div>
                            </Col>
                        ))}
                    </Row>
                    
                    {/* BOOK NOW Button - Centered - UPDATED */}
                </Container>
                {selectedData != null && <ImageModal image={selectedData} show={showImageModal} handleClose={handleCloseImageModal} />}
            </div>

            {/* Booking Form Modal - DARK BLUE THEME */}
            <Modal 
                show={showBookingModal} 
                onHide={handleCloseBookingModal}
                centered
                size="lg"
                contentClassName="border-0"
                style={{ overflow: 'hidden' }}
            >
                {/* Modal Header with Dark Blue Background */}
                <div style={{
                    backgroundColor: '#001f3f', // Dark blue
                    padding: '30px 30px 20px 30px',
                    borderTopLeftRadius: 'calc(0.3rem - 1px)',
                    borderTopRightRadius: 'calc(0.3rem - 1px)'
                }}>
                    <div className="d-flex justify-content-end">
                        <button 
                            type="button" 
                            className="btn-close btn-close-white" 
                            onClick={handleCloseBookingModal}
                            aria-label="Close"
                            style={{
                                opacity: 1,
                                fontSize: '1.5rem',
                                padding: '10px'
                            }}
                        />
                    </div>
                    
                    {/* Mila Logo as Header - SIZE DOUBLED */}
                    <div className="text-center mb-3">
                        <Image 
                            src={milaLogo}
                            alt="Mila Logo"
                            style={{
                                maxWidth: '240px', // Changed from 120px to 240px (doubled)
                                width: '100%',
                                height: 'auto',
                                marginBottom: '10px'
                            }}
                        />
                        <div style={{ 
                            fontSize: '18px',
                            fontWeight: 'normal',
                            color: '#ffffff',
                            letterSpacing: '2px',
                            marginTop: '5px'
                        }}>
                            
                        </div>
                    </div>
                </div>
                
                {/* Modal Body with Dark Blue Background */}
                <div style={{
                    backgroundColor: '#001f3f', // Dark blue
                    padding: '0 30px 30px 30px',
                    borderBottomLeftRadius: 'calc(0.3rem - 1px)',
                    borderBottomRightRadius: 'calc(0.3rem - 1px)'
                }}>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            {/* Name and Surname */}
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={{ 
                                        fontWeight: 'bold',
                                        color: '#ffffff' // White text
                                    }}>NAME</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        placeholder="JOHN"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                        style={{
                                            backgroundColor: '#0a2d56', // Darker blue input
                                            borderColor: '#003366',
                                            color: '#ffffff'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={{ 
                                        fontWeight: 'bold',
                                        color: '#ffffff' // White text
                                    }}>SURNAME</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="surname"
                                        placeholder="DOE"
                                        value={formData.surname}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                        style={{
                                            backgroundColor: '#0a2d56', // Darker blue input
                                            borderColor: '#003366',
                                            color: '#ffffff'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Number of People */}
                        <Form.Group className="mb-3">
                            <Form.Label style={{ 
                                fontWeight: 'bold',
                                color: '#ffffff' // White text
                            }}>NUMBER OF PEOPLE</Form.Label>
                            <Form.Select
                                name="numberOfPeople"
                                value={formData.numberOfPeople}
                                onChange={handleInputChange}
                                required
                                disabled={isSubmitting}
                                style={{
                                    backgroundColor: '#0a2d56', // Darker blue input
                                    borderColor: '#003366',
                                    color: '#ffffff'
                                }}
                            >
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10+">10+</option>
                            </Form.Select>
                        </Form.Group>

                        <Row>
                            {/* Booking Date */}
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={{ 
                                        fontWeight: 'bold',
                                        color: '#ffffff' // White text
                                    }}>BOOKING DATE</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="bookingDate"
                                        value={formData.bookingDate}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                        style={{
                                            backgroundColor: '#0a2d56', // Darker blue input
                                            borderColor: '#003366',
                                            color: '#ffffff'
                                        }}
                                    />
                                    <Form.Text style={{ 
                                        color: '#a0c4ff' // Light blue text
                                    }}>
                                        Format: DD/MM/YY
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                            
                            {/* Booking Time */}
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={{ 
                                        fontWeight: 'bold',
                                        color: '#ffffff' // White text
                                    }}>BOOKING TIME</Form.Label>
                                    <Form.Control
                                        type="time"
                                        name="bookingTime"
                                        value={formData.bookingTime}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                        style={{
                                            backgroundColor: '#0a2d56', // Darker blue input
                                            borderColor: '#003366',
                                            color: '#ffffff'
                                        }}
                                    />
                                    <Form.Text style={{ 
                                        color: '#a0c4ff' // Light blue text
                                    }}>
                                        Format: 00:00 AM/PM
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Email */}
                        <Form.Group className="mb-3">
                            <Form.Label style={{ 
                                fontWeight: 'bold',
                                color: '#ffffff' // White text
                            }}>EMAIL</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                placeholder="JOHN.DOE@GMAIL.COM"
                                value={formData.email}
                                onChange={handleInputChange}
                                required
                                disabled={isSubmitting}
                                style={{
                                    backgroundColor: '#0a2d56', // Darker blue input
                                    borderColor: '#003366',
                                    color: '#ffffff'
                                }}
                            />
                        </Form.Group>

                        {/* Phone Number */}
                        <Form.Group className="mb-3">
                            <Form.Label style={{ 
                                fontWeight: 'bold',
                                color: '#ffffff' // White text
                            }}>PHONE NUMBER</Form.Label>
                            <Form.Control
                                type="tel"
                                name="phone"
                                placeholder="+971501234567"
                                value={formData.phone}
                                onChange={handleInputChange}
                                required
                                disabled={isSubmitting}
                                style={{
                                    backgroundColor: '#0a2d56', // Darker blue input
                                    borderColor: '#003366',
                                    color: '#ffffff'
                                }}
                            />
                        </Form.Group>

                        {/* Submit Button - COMMENTED OUT/HIDDEN */}
                        {/* REMOVE THIS LINE TO RESTORE BUTTON
                        <div className="text-center mt-4">
                            <Button 
                                type="submit"
                                className="px-5 py-2"
                                style={{
                                    backgroundColor: isSubmitting ? '#4a6fa5' : '#003594',
                                    borderColor: isSubmitting ? '#4a6fa5' : '#003594',
                                    fontSize: '1.1rem',
                                    fontWeight: 'bold',
                                    borderRadius: '25px',
                                    minWidth: '150px'
                                }}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'SUBMITTING...' : 'BOOK'}
                            </Button>
                            
                            {/* Success/Error Message * /}
                            {submitMessage && (
                                <div className="mt-3" style={{
                                    padding: '10px',
                                    borderRadius: '5px',
                                    backgroundColor: submitMessage.includes('✅') ? '#d4edda' : '#f8d7da',
                                    color: submitMessage.includes('✅') ? '#155724' : '#721c24',
                                    fontSize: '0.9rem'
                                }}>
                                    {submitMessage}
                                </div>
                            )}
                        </div>
                        REMOVE THIS LINE TO RESTORE BUTTON */}
                    </Form>
                </div>
            </Modal>
        </>
    );
}

export default Section5;